import { render } from "./RichCtaCard.vue?vue&type=template&id=5eea36e0"
import script from "./RichCtaCard.vue?vue&type=script&lang=js"
export * from "./RichCtaCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__